import { render } from "./ClienteModal.vue?vue&type=template&id=b88b4f14&scoped=true"
import script from "./ClienteModal.vue?vue&type=script&lang=js"
export * from "./ClienteModal.vue?vue&type=script&lang=js"

import "./ClienteModal.vue?vue&type=style&index=0&id=b88b4f14&scoped=true&lang=css"
import "./ClienteModal.vue?vue&type=style&index=1&id=b88b4f14&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88b4f14"]])

export default __exports__